export function phoneNumberIsValid(phoneNumber: string): boolean
{
  return !!phoneNumber && !!phoneNumber.match(/^[\d()-]{10,15}$/)
}
